module.exports = __webpack_public_path__ + "static/media/vr-live-logo.5302dc6a.svg";